"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var odc_frame_1 = __importDefault(require("@tencent/odc-frame"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var events = ['onKeyPress', 'onKeyUp', 'onKeyDown', 'onMouseOver', 'onMouseOut', 'onMouseEnter', 'onMouseLeave', 'onClick', 'onScroll'];
var Flex = function Flex(props, ref) {
  var children = props.children,
    start = props.start,
    center = props.center,
    end = props.end,
    startProps = props.startProps,
    centerProps = props.centerProps,
    endProps = props.endProps,
    _a = props.direction,
    direction = _a === void 0 ? 'row' : _a,
    _b = props.inline,
    inline = _b === void 0 ? false : _b,
    justifyContent = props.justifyContent,
    alignItems = props.alignItems,
    itemsCenter = props.itemsCenter,
    justifyCenter = props.justifyCenter,
    bothCenter = props.bothCenter,
    w = props.w,
    h = props.h,
    gap = props.gap,
    radius = props.radius,
    _c = props.wrap,
    wrap = _c === void 0 ? false : _c,
    _d = props.isColumn,
    isColumn = _d === void 0 ? false : _d,
    _e = props.column,
    column = _e === void 0 ? false : _e,
    restProps = __rest(props, ["children", "start", "center", "end", "startProps", "centerProps", "endProps", "direction", "inline", "justifyContent", "alignItems", "itemsCenter", "justifyCenter", "bothCenter", "w", "h", "gap", "radius", "wrap", "isColumn", "column"]);
  return react_1["default"].createElement(odc_frame_1["default"], __assign({}, restProps, (0, spaui_utils_1.globalProps)(props, {
    className: 'odc-flex',
    events: events,
    ref: ref
  }, Flex), {
    flex: !inline ? true : null,
    direction: isColumn || column ? 'column' : direction,
    inlineFlex: inline,
    justifyContent: justifyCenter || bothCenter ? 'center' : justifyContent,
    alignItems: itemsCenter || bothCenter ? 'center' : alignItems,
    w: w,
    h: h,
    radius: radius,
    gap: gap,
    flexWrap: wrap
  }), start ? react_1["default"].createElement(odc_frame_1["default"], __assign({
    className: "odc-flex-start"
  }, startProps), start) : null, center ? react_1["default"].createElement(odc_frame_1["default"], __assign({
    className: "odc-flex-center"
  }, centerProps), center) : null, end ? react_1["default"].createElement(odc_frame_1["default"], __assign({
    className: "odc-flex-end"
  }, endProps), end) : null, children);
};
(0, spaui_utils_1.setComponentMark)(Flex, info_1["default"]);
exports["default"] = react_1["default"].memo(react_1["default"].forwardRef(Flex));